import React from "react";
import { Modal } from "antd";
import { getPermissionGroupLabel, getPermissionLabel, getPermissionValue } from "./adminUtils";
import "./AdminManagement.css";
import closeButton from "../../assets/closeButton.svg";

const AdminPermissionsModal = ({ open, onClose, permissionGroups = [] }) => {
  const groups = permissionGroups
    .map((group) => ({
      ...group,
      permissions: (group.permissions || []).filter(
        (permission) =>
          permission?.checked !== false &&
          (typeof permission === "string" || permission?.label),
      ),
    }))
    .filter((group) => group.permissions?.length);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closeIcon={null}
      centered
      className="admin-permissions-modal"
      destroyOnClose
    >
      <div className="admin-permissions-modal-header">
        <h2 className="admin-permissions-modal-title">Admin Permissions</h2>
        <button
          type="button"
          className="admin-permissions-modal-close cursor-pointer"
          onClick={onClose}
          aria-label="Close"
        >
          <img src={closeButton} alt="" width={16} height={16} />
        </button>
      </div>

      <div className="admin-permissions-modal-body">
        {groups.length === 0 ? (
          <p className="admin-permissions-empty">No permissions assigned.</p>
        ) : (
          groups.map((group, index) => (
            <React.Fragment key={getPermissionGroupLabel(group)}>
              {index > 0 && <div className="admin-permissions-divider" />}
              <div className="admin-permissions-section">
                <h3 className="admin-permissions-category">
                  {getPermissionGroupLabel(group)}
                </h3>                <div className="admin-permissions-tags">
                  {group.permissions.map((permission) => {
                    const permissionValue = getPermissionValue(permission);

                    return (
                      <span
                        key={permissionValue}
                        className="admin-permission-tag"
                      >
                        {getPermissionLabel(permission)}
                      </span>
                    );
                  })}
                </div>
              </div>
            </React.Fragment>
          ))
        )}
      </div>
    </Modal>
  );
};

export default AdminPermissionsModal;